import { useField } from 'react-final-form';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const allTabs = [
  {
    label: 'Instant booking',
    value: 'instant',
  },
  {
    label: 'Group booking',
    value: 'group',
  },
];

interface BookingTypeTabProps {
  name: string;
  showGroupBooking?: boolean;
}

export const BookingTypeTab = ({
  name,
  showGroupBooking = true,
}: BookingTypeTabProps) => {
  const { input } = useField(name);

  const tabs = showGroupBooking
    ? allTabs
    : allTabs.filter((tab) => tab.value !== 'group');

  return (
    <div className="hidden sm:block">
      <div className="border-b border-gray-200">
        <div aria-label="Tabs" className="-mb-px flex space-x-8" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={tab.value === input.value}
              onClick={() => input.onChange(tab.value)}
              className={classNames(
                input.value === tab.value
                  ? 'border-primaryBlue text-primaryBlue'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap bg-transparent cursor-pointer',
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
